import axios from "axios";

const GOOGLE_TRANSLATE_URL = "https://translate.googleapis.com/translate_a/single";
const MAX_CHUNK_LENGTH = 1800;

const splitForTranslation = (text) => {
  const chunks = [];
  let remaining = text;

  while (remaining.length > MAX_CHUNK_LENGTH) {
    const boundary = remaining.lastIndexOf("\n", MAX_CHUNK_LENGTH);
    const length = boundary > 0 ? boundary + 1 : MAX_CHUNK_LENGTH;
    chunks.push(remaining.slice(0, length));
    remaining = remaining.slice(length);
  }

  if (remaining) chunks.push(remaining);
  return chunks;
};

export async function translateAgreementText(text, targetLanguage) {
  const source = String(text || "");
  if (!source || targetLanguage !== "en") return source;

  const translatedChunks = await Promise.all(
    splitForTranslation(source).map(async (chunk) => {
      const response = await axios.get(GOOGLE_TRANSLATE_URL, {
        params: {
          client: "gtx",
          sl: "it",
          tl: "en",
          dt: "t",
          q: chunk,
        },
      });
      return Array.isArray(response.data?.[0])
        ? response.data[0].map((part) => part?.[0] || "").join("")
        : chunk;
    })
  );

  return translatedChunks.join("");
}
